module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-BoldItalic.9e3b0bff.otf";